import { FunctionComponent, useState } from 'react';
import Dropdown, { DropdownProps } from '../dropdown';
import RadioStack, { RadioStackProps } from '../radio-stack';
import { RadioStackContainer } from '../common';

export interface DropdownListProps extends Omit<DropdownProps, 'active'> {
  radioStackProps: RadioStackProps;
}

const DropdownList: FunctionComponent<DropdownListProps> = (props) => {
  const { radioStackProps } = props;

  const [isActive, setIsActive] = useState(false);

  const onToggleDropdown = (active: boolean) => {
    setIsActive(active);
  };

  return (
    <Dropdown
      {...props}
      active={isActive}
      onToggleActive={onToggleDropdown}
      fullWidth={true}
    >
      <RadioStackContainer onClick={() => onToggleDropdown(false)}>
        <RadioStack {...radioStackProps} />
      </RadioStackContainer>
    </Dropdown>
  );
};

export default DropdownList;
